import { useEffect, useState } from "react";
import * as api from "../../api";
import Icon from "../Icon";
import Dialogo from "./Dialogo";
import HiloEncargo from "./HiloEncargo";
import { etiquetaDia } from "./planes";
import { textoPrioridad } from "./ChipPrioridad";

const iniciales = n => String(n || "").split(" ").map(x => x[0]).join("").slice(0, 2);

// Rechazar: el motivo es OPCIONAL; quien la propuso lo ve y puede proponer otra.
function RechazarModal({ item, onCerrar, onRechazar }) {
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);
  const enviar = async e => {
    e.preventDefault();
    setEnviando(true); setError("");
    try { await onRechazar(motivo.trim()); }
    catch (err) { setError(err?.message || "No se ha podido rechazar la propuesta"); setEnviando(false); }
  };
  return (
    <Dialogo titulo="Rechazar propuesta" onCerrar={onCerrar} ancho={420}>
      <form className="mt-form" onSubmit={enviar} noValidate>
        <p className="mt-nopuedo-t">{item.titulo}</p>
        <p className="mt-sel-nota">{item.emisor?.nombre || "Quien la propuso"} verá tu respuesta y recibirá un aviso.</p>
        <label className="mt-lb" htmlFor="mt-rechazo">Motivo (opcional)</label>
        <textarea id="mt-rechazo" className="mt-inp" rows={3} maxLength={500} value={motivo} onChange={e => setMotivo(e.target.value)}
          placeholder="Por ejemplo: ya está previsto para el trimestre que viene" />
        {error && <div className="mt-plan-aviso" role="alert"><span>{error}</span></div>}
        <div className="mt-dlg-pie">
          <button type="button" className="mt-b btn" onClick={onCerrar}>Cancelar</button>
          <button type="submit" className="mt-b mt-no btn" disabled={enviando}>Rechazar</button>
        </div>
      </form>
    </Dialogo>
  );
}

// «Por aprobar»: las propuestas que ESTA persona (gestor o admin) puede resolver. Aprobar es un clic y no pide confirmacion;
// rechazar abre un motivo opcional. No se pueden aprobar las propias: otra persona tiene que hacerlo.
export default function PorAprobarTab({ miId, onCambio, showToast }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [v, setV] = useState(0);
  const [rechazando, setRechazando] = useState(null);
  const [hilo, setHilo] = useState(null);
  const [ocupado, setOcupado] = useState(null);

  useEffect(() => {
    let vivo = true;
    api.getPorAprobar()
      .then(d => { if (vivo) { setItems(Array.isArray(d?.items) ? d.items : []); setError(""); } })
      .catch(e => { if (vivo) setError(e?.message || "No se han podido cargar las propuestas"); });
    return () => { vivo = false; };
  }, [v]);

  const recargar = () => { setV(x => x + 1); onCambio?.(); };
  const aprobar = async it => {
    setOcupado(it.id);
    try { await api.aprobarEncargo(it.id); showToast?.(`Aprobada: ${it.titulo}`); recargar(); }
    catch (e) { showToast?.(e?.status === 409 ? "Otra persona ya la ha resuelto" : (e?.message || "No se ha podido aprobar"), e?.status === 409 ? "warn" : "error"); recargar(); }
    setOcupado(null);
  };
  const rechazar = async motivo => {
    await api.rechazarEncargo(rechazando.id, motivo);
    showToast?.(`Rechazada: ${rechazando.titulo}`);
    setRechazando(null);
    recargar();
  };

  if (error) {
    return <div className="mt-vacio" role="alert"><b>{error}</b>
      <button type="button" className="btn mt-reintentar" onClick={() => setV(x => x + 1)}>Reintentar</button></div>;
  }
  if (!items) return <p className="mt-estado-pag" role="status">Cargando las propuestas…</p>;
  if (!items.length) {
    return (
      <div className="mt-vacio">
        <b>No hay propuestas pendientes</b>
        Cuando alguien de tu equipo te proponga una tarea, la verás aquí para aprobarla o rechazarla.
      </div>
    );
  }
  return (
    <div>
      {items.map(it => {
        const propia = miId != null && String(it.emisor?.id) === String(miId);
        const prio = textoPrioridad(it.prioridad);
        return (
          <section key={it.id} className="mt-aprob" aria-label={`Propuesta: ${it.titulo}`}>
            <div className="mt-titulo">{it.titulo}</div>
            <div className="mt-aprob-de">
              <span className="mt-av" aria-hidden="true">{iniciales(it.emisor?.nombre)}</span>
              <span>
                <b>{propia ? "Tú" : it.emisor?.nombre}</b>{" "}
                {it.a_si_mismo ? (propia ? "te la propones a ti mismo" : "se la propone a sí mismo")
                  : <>{propia ? "la propones" : "la propone"} para <b>{it.receptor?.nombre}</b></>}
              </span>
              {it.receptor?.equipo && <span className="mt-proyecto"><span>{it.receptor.equipo}</span></span>}
            </div>
            <div className="mt-meta">
              {it.fecha_limite && <span>Límite {etiquetaDia(it.fecha_limite)}</span>}
              {prio && it.prioridad !== 1 && <span>{prio}</span>}
              {it.tiempo_estimado_min ? <span>≈ {Math.round(it.tiempo_estimado_min / 6) / 10} h</span> : null}
              {it.proyecto?.nombre && <span>{it.proyecto.nombre}</span>}
            </div>
            {it.descripcion && <div className="mt-desc">{it.descripcion}</div>}
            {propia ? (
              <p className="mt-sel-nota">Otra persona tiene que aprobarla: no puedes aprobar tus propias propuestas.</p>
            ) : (
              <div className="mt-aprob-acc">
                <button type="button" className="mt-hecha-b btn" disabled={ocupado === it.id} onClick={() => aprobar(it)}>
                  <Icon name="check2" size={14} color="currentColor" /><span>Aprobar</span>
                </button>
                <button type="button" className="mt-b mt-no btn" onClick={() => setRechazando(it)}>Rechazar</button>
                <button type="button" className="mt-b btn" onClick={() => setHilo(it)}
                  aria-label={`Ver la conversación: ${it.titulo}${it.mensajes_total ? `, ${it.mensajes_total} comentarios` : ""}`}>
                  <Icon name="chat-dots-fill" size={13} color="currentColor" />{it.mensajes_total ? ` ${it.mensajes_total}` : ""}
                </button>
              </div>
            )}
          </section>
        );
      })}
      {rechazando && <RechazarModal item={rechazando} onCerrar={() => setRechazando(null)} onRechazar={rechazar} />}
      {hilo && <HiloEncargo encargoId={hilo.id} titulo={hilo.titulo} onCerrar={() => setHilo(null)} onComentado={() => setV(x => x + 1)} />}
    </div>
  );
}
